import { ComparisonModes } from '@/entities/market-intel/model/types';
import type { SelectOption } from '@/shared/ui';
import type { PeriodSelectorState } from '@/widgets/period-selector';
import dayjs from 'dayjs';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type MarketIntelPageState = {
  selectedFacilityId: string;
  periodSelectorState: PeriodSelectorState;
  comparisonMode: ComparisonModes;
  isCompSet: boolean;
};

type MarketIntelActions = {
  changePeriodSelectorState: (state: PeriodSelectorState) => void;
  changeComparisonMode: (checked: boolean) => void;
  changeSelectedFacilityId: (facilityOption: SelectOption) => void;
};

const initialState: MarketIntelPageState = {
  selectedFacilityId: '',
  periodSelectorState: {
    dateRange: {
      from: dayjs().subtract(1, 'month').startOf('month'),
      to: dayjs().subtract(1, 'month').startOf('month'),
    },
    renderedDateRange: {
      from: dayjs().subtract(1, 'month').startOf('month'),
      to: dayjs().subtract(1, 'month').startOf('month'),
    },
  },
  comparisonMode: ComparisonModes.INTERNAL,
  isCompSet: false,
};

export const useMarketIntelStore = create<
  MarketIntelPageState & MarketIntelActions
>()(
  immer((set) => ({
    ...initialState,
    changeSelectedFacilityId: (facilityOption: SelectOption) => {
      set((state) => {
        state.selectedFacilityId = facilityOption.value;
      });
    },
    changePeriodSelectorState: (newPeriodSelectorState) => {
      set((state) => {
        state.periodSelectorState = newPeriodSelectorState;
      });
    },
    changeComparisonMode: (checked: boolean) => {
      set((state) => {
        state.comparisonMode = checked
          ? ComparisonModes.COMP
          : ComparisonModes.INTERNAL;

        state.isCompSet = checked;
      });
    },
  }))
);
